import { useCallback, useState } from 'react';
import { dockingStates } from './constants';
import QueryContent from './QueryContent';
import ResultContent from './ResultContent';
import { SidePanelContainer } from '../../info_display/SidePanel';
import useEventBrokerSubscription from '../../common/helpers/useEventBrokerSubscription';

const initialState = {
    requestedCompounds: [],
    dockState: dockingStates.READY,
    dockResult: null,
};

export default function DockingPane({ open, setOpen, handleClose }) {
    const [requestedCompounds, setRequestedCompounds] = useState(initialState.requestedCompounds);
    const [dockState, setDockState] = useState(initialState.dockState);
    const [dockResult, setDockResult] = useState(initialState.dockResult);

    const handleZap = useCallback(() => {
        setRequestedCompounds(initialState.requestedCompounds);
        setDockState(initialState.dockState);
        setDockResult(initialState.dockResult);
    }, []);

    const handleAskDock = useCallback((_, { compounds }) => {
        setOpen(true);

        if (dockState !== dockingStates.IN_PROGRESS) {
            setDockState(dockingStates.READY);
            setRequestedCompounds(compounds);
            setDockResult(null);
        }
    }, [dockState, setOpen]);

    const handleProteinsChanged = useCallback(() => {
        setOpen(false);
    }, [setOpen]);

    function preDock() {
        setDockState(dockingStates.IN_PROGRESS);
    }

    function postDock(result) {
        if (result.cancelled) {
            if (!open) {
                setDockState(dockingStates.READY);
                setDockResult(null);
            } else {
                // In this case, the docking was cancelled, but the pane was opened up
                // before the job finished. Show "cancelled" instead of just abruptly closing.
                setDockState(dockingStates.COMPLETE);
                setDockResult({ compounds: [], errors: ['Docking cancelled.'] });
            }
        } else {
            setOpen(true);
            setDockState(dockingStates.COMPLETE);
            setDockResult(result);
        }
    }

    useEventBrokerSubscription('askDock', handleAskDock);
    useEventBrokerSubscription('zapAll', handleZap);
    useEventBrokerSubscription('proteinsChanged', handleProteinsChanged);

    return (
        <SidePanelContainer title="Docking" open={open} handleClose={handleClose} width="25rem">
            {dockState === dockingStates.READY
                ? (
                    <QueryContent
                        handleClose={handleClose}
                        preDock={preDock}
                        postDock={postDock}
                        requestedCompounds={requestedCompounds}
                    />
                ) : (
                    <ResultContent
                        result={dockResult}
                        dockState={dockState}
                        handleClose={handleClose}
                    />
                )}
        </SidePanelContainer>
    );
}
